import Browser from './../../../services/Browser'
import { GRAY, PRIMARY_COLOR } from '../../../styles/colors.style'
import { borderRadius } from '../../../styles/reusable.style'

export const selectStyles = {
	menuPortal: base => ({ ...base, zIndex: 4 }),
	option: (base, state) => ({
		...base,
		color: state.isFocused ? 'white' : GRAY,
		padding: '1.5rem',
		fontSize: '16px',
		background: state.isFocused ? PRIMARY_COLOR : 'white'
	}),
	control: (base, state) => ({
		...base,
		outline: 'none',
		boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.15)',
		fontSize: '16px',
		padding: '0',
		background: state.isDisabled ? '#F6F7F9' : 'white',
		border: `1px solid ${
			state.isFocused ? PRIMARY_COLOR : '#E0E0E0'
		} !important`,
		borderRadius: borderRadius,
		color: `${GRAY}`,
		height: '45px !important'
	}),
	valueContainer: (base, state) => ({
		...base,
		overflow: 'hidden'
	}),
	singleValue: (base, state) => ({
		...base,
		color: GRAY,
		fontSize: '16px',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	}),
	placeholder: (base) => ({
		...base,
		color: GRAY,
		fontSize: '16px'
	}),
	dropdownIndicator: (base, state) => ({
		...base,
		padding: '1rem'
	}),
	clearIndicator: (base, state) => ({
		...base,
		display: 'none'
	})
}
